import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import translate from "@insite/client-framework/Translate";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductSubAssemblyProduct from "@store/Components/Store/ProductSubAssemblyProduct";
import ProductSubAssemblyProductCard from "@store/Components/Store/ProductSubAssemblyProductCard";
import { COLORS } from "@store/theme/design";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    displayAsTable: boolean;
}

export interface ProductSubAssemblyStyles {
    wrapper?: InjectableCss;
    tableHeader?: DataTableHeaderProps;
}

const mapStateToProps = (state: ApplicationState) => ({
    products: getProductsForProductInfoList(state, "subAssemblyItems"),
    userName: state.context.session?.userName,
});

const mapDispatchToProps = {
    loadCarouselProducts,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const productSubAssemblyStyles: ProductSubAssemblyStyles = {
    wrapper: {
        css: css`
            overflow: auto;
            border: 1px solid ${COLORS.border.base};
        `,
    },
    tableHeader: {
        style: {
            background: `${COLORS.text.light}`,
        },
        typographyProps: {
            color: "white",
        },
    },
};

const styles = productSubAssemblyStyles;

const ProductSubAssemblyItems: React.FC<Props> = ({ products, userName, displayAsTable }) => {
    return (
        <>
            {!displayAsTable && products && (
                <StyledWrapper {...styles.wrapper}>
                    {products.map((product, index) => (
                        <ProductSubAssemblyProductCard
                            product={product}
                            key={product.id}
                            productNumber={product.productNumber}
                            productTitle={product.productTitle}
                            id={product.id}
                        ></ProductSubAssemblyProductCard>
                    ))}
                </StyledWrapper>
            )}
            {displayAsTable && products && (
                <StyledWrapper {...styles.wrapper}>
                    <DataTable>
                        <DataTableHead>
                            <DataTableHeader {...styles.tableHeader} title="Image"></DataTableHeader>
                            <DataTableHeader {...styles.tableHeader} title="Name">
                                {translate("Name")}
                            </DataTableHeader>
                            <DataTableHeader {...styles.tableHeader} title="Brand">
                                {translate("Brand")}
                            </DataTableHeader>
                            <DataTableHeader {...styles.tableHeader}>{translate("SKU")}</DataTableHeader>
                            {userName ? (
                                <>
                                    <DataTableHeader {...styles.tableHeader}>{translate("Quantity")}</DataTableHeader>
                                    <DataTableHeader {...styles.tableHeader}>{translate("Unit Price")}</DataTableHeader>
                                </>
                            ) : (
                                <DataTableHeader {...styles.tableHeader}></DataTableHeader>
                            )}

                            <DataTableHeader {...styles.tableHeader} title="ViewProduct"></DataTableHeader>
                        </DataTableHead>
                        <DataTableBody>
                            {products.map(product => (
                                <ProductSubAssemblyProduct
                                    product={product}
                                    key={product.id}
                                    productNumber={product.productNumber}
                                    productTitle={product.productTitle}
                                    id={product.id}
                                ></ProductSubAssemblyProduct>
                            ))}
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSubAssemblyItems);
